export const resources = {
  STATE_RESOURCE: 'STATE_RESOURCE',
  CONTEXT_RESOURCE: 'CONTEXT_RESOURCE',
  HISTORY_RESOURCE: 'HISTORY_RESOURCE',
  ROUTE_RESOURCE: 'ROUTE_RESOURCE',
  DRAG_STATE_RESOURCE: 'DRAG_STATE_RESOURCE',
  CHILD_RESOURCE: 'CHILD_RESOURCE',
  THEME_RESOURCE: 'THEME_RESOURCE',
  EDITOR_RESOURCE: 'EDITOR_RESOURCE',
  SELECTION_RESOURCE: 'SELECTION_RESOURCE',
  ASSET_RESOURCE: 'ASSET_RESOURCE',
};

export const methods = {
  GET: 'GET',
  SET: 'SET',
  SUBSCRIBE: 'SUBSCRIBE',
  SUBSCRIBE_TO_DRAGGABLES: 'SUBSCRIBE_TO_DRAGGABLES',
  INIT_CHILD: 'INIT_CHILD',
  SUBSCRIBE_TO_THEME_CSS: 'SUBSCRIBE_TO_THEME_CSS',
  SUBSCRIBE_TO_SELECTION: 'SUBSCRIBE_TO_SELECTION',
  ASSET_RESOLVE: 'ASSET_RESOLVE',
  ASSET_CREATE: 'ASSET_CREATE',
};

